module.exports = __webpack_public_path__ + "img/dominik-schmied.c425b76c.jpg";